import BotaoFaleConosco from "@/components/BotaoFaleConosco";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid2";
import Typography from "@mui/material/Typography";
import { Helmet } from "react-helmet";
import DuvidasFrequentes from "../../commom/duvidas-frequentes";
import "./Perguntas.scss";

export default function Perguntas() {
  return (
    <>
      <Container className="secao-site-perguntas secao-faq" component="main">
        <Helmet>
          <title>Perguntas</title>
          <link
            rel="canonical"
            href="https://quitaboletos.com.br/como-funciona"
          />
          <meta
            name="description"
            content="Parcele PIX ou boleto em até 12x no cartão de crédito"
          />
        </Helmet>

        <Typography
          variant="h1"
          sx={{
            fontWeight: "900",
            fontSize: "2.5rem",
            mb: 3,
            color: "#104501",
          }}>
          PERGUNTAS
        </Typography>
        <Typography sx={{ fontSize: "1.5rem", mb: 3 }}>
          <strong>Com dúvidas?</strong> É só conferir que respondemos as
          perguntas mais comuns.
        </Typography>

        <Grid container maxWidth="md">
          <DuvidasFrequentes />

          <Grid size={{ xs: 12, md: 6 }} sx={{ mt: 2 }}>
            <Typography sx={{ fontSize: "2.4rem", fontWeight: "bold", mb: 3 }}>
              Ainda tem dúvidas?{" "}
            </Typography>
            <Typography sx={{ fontSize: "1.2rem" }}>
              É só escolher um dos nossos canais de atendimento ao cliente que
              vamos oferecer todo o suporte necessário.
            </Typography>
          </Grid>
          <Grid
            size={{ xs: 12, md: 6 }}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}>
            <BotaoFaleConosco className="botao-fale-conosco-amarelo">
              FALE COM A GENTE AGORA
            </BotaoFaleConosco>
          </Grid>
        </Grid>
      </Container>

      <Container className="secao-site-perguntas secao-faq" component="section">
        <Grid container maxWidth="md">
          <Grid
            item
            size={{ xs: 12, md: 6 }}
            sx={{ textAlign: { xs: "center", md: "left" } }}>
            <Typography
              sx={{
                fontWeight: "bold",
                fontSize: { xs: "3rem", sm: "4rem" },
                mb: 3,
                color: "#104501",
              }}>
              Atendimento e suporte dedicados!
            </Typography>

            <Grid sx={{ pt: { xs: 4, md: 2 } }}>
              <img src="/site/icon-smile.png" alt="icone sorriso" />
            </Grid>
          </Grid>
          <Grid item size={{ xs: 12, md: 6 }} sx={{ mt: 5 }}>
            <Typography sx={{ fontSize: "1.5rem", mb: 3 }}>
              Nosso horário de atendimento no WhatsApp é de segunda a
              sexta-feira, das 08:30 às 18:30. E aos sábados, das 09h às 12h,
              exceto feriados nacionais.
            </Typography>
            <Typography sx={{ fontSize: "1.2rem", mb: 3 }}>
              * Disponibilizamos um bot automático, especializado em responder
              às principais dúvidas, 24 horas por dia.
            </Typography>

            <BotaoFaleConosco
              className="botao-fale-conosco-verde"
              startIcon={<WhatsAppIcon color="#d8ff57" />}>
              FALE COM A GENTE AGORA
            </BotaoFaleConosco>
          </Grid>
        </Grid>
      </Container>
    </>
  );
}
